var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ed-movimento',{key:_vm.$root.$session.versao+'1443',attrs:{"intCabecalhoMovimentoId":_vm.$route.params.intId,"intTipoMovimentoId":1443}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }